import React, { useState, useEffect } from "react";
import { IconComponentProps } from "../interface";
import defaultSvg from "../../assets/icons/svg/default.svg";
import TooltipComponent from "@CubeComponents/html/tooltip";
import { IconButton } from "@mui/material";

const iconModules = import.meta.glob("../../assets/icons/svg/**/*.svg", { import: "default" });

const IconComponent: React.FC<IconComponentProps> = ({
  name,
  cssClass,
  className,
  isVisible = true,
  isEnabled = true,
  showGradient = false,
  color = null,
  toolTipContent = "",
  position = "top",
  type,
  onClick,
  height = "24px",
  width = "24px",
  menuShow,
  children,
  key = "",
  dataTestId = "",
  parentContainerClass = "",
}: any) => {
  const [iconSrc, setIconSrc] = useState<string | null | false>(null);

  const initIcon = async () => {
    if (name) {
      const key = `../../assets/icons/svg/${name}.svg`;
      const loader: any = iconModules[key];
      if (!loader) {
        setIconSrc(false);
      } else {
        setIconSrc(await loader());
      }
    } else {
      setIconSrc(null);
    }
  };

  useEffect(() => {
    initIcon();
  }, [name]);

  const handleIconClick = (args: any) => {
    if (isEnabled && onClick) {
      onClick(args);
    }
  };
  const getIcon = () => (
    <IconButton
      key={key}
      data-testid={dataTestId}
      type={type}
      onClick={handleIconClick}
      disabled={!isEnabled || !(onClick || toolTipContent)}
      className={parentContainerClass}
      sx={{
        "&.Mui-focusVisible": {
          outline: "2px solid #6BBBE3",
          outlineOffset: "2px",
        },
        "&:hover": {
          backgroundColor: "transparent",
        },
      }}
      style={{
        cursor: isEnabled ? "pointer" : "not-allowed",
        width: "max-content",
        height: "max-content",
        verticalAlign: "top",
        padding: "0px",
        display: "flex",
      }}
    >
      {showGradient ? (
        <div
          style={{
            width,
            height,
            background: color ?? "linear-gradient(to right, #6BBBE3, #3E8AB0)",
            maskImage: `url("${iconSrc}")`,
            maskRepeat: "no-repeat",
            maskSize: "contain",
            WebkitMaskImage: `url("${iconSrc}")`,
            WebkitMaskRepeat: "no-repeat",
            WebkitMaskSize: "contain",
          }}
          className={`${cssClass} ${className} ${isEnabled ? "" : "opacity-40"}`}
        />
      ) : (
        <img
          src={iconSrc || defaultSvg}
          alt={name || "default-icon"}
          className={`${cssClass} ${className} ${isEnabled ? "" : "opacity-40"}`}
        />
      )}
      {children && menuShow && <>{children}</>}
    </IconButton>
  );
  return isVisible ? (
    <>
      {iconSrc !== null &&
        (toolTipContent ? (
          <TooltipComponent content={toolTipContent} position={position}>
            {getIcon()}
          </TooltipComponent>
        ) : (
          getIcon()
        ))}
    </>
  ) : (
    ""
  );
};

export default IconComponent;
